import React from 'react';

export default function WorkerAllocation({ item, workers, canAssign, saving, error, workersError, onAssign }) {
  return (
    <div>
      {canAssign ? (
        <select
          className="worker-dropdown"
          aria-label={`Assign worker for ${item.customer} (${item.id})`}
          value={item.workerId || ''}
          disabled={Boolean(saving) || !/^\d+$/.test(String(item.id)) || Boolean(workersError)}
          onChange={(event) => onAssign(item.id, event.target.value)}
        >
          <option value="">{item.worker && !item.workerId ? item.worker : 'Unassigned'}</option>
          {item.workerId && !workers.some((worker) => worker.id === item.workerId) && (
            <option value={item.workerId} disabled>{item.worker || 'Unavailable user'}</option>
          )}
          {workers.map((worker) => (
            <option key={worker.id} value={worker.id}>{worker.firstName} {worker.lastName}</option>
          ))}
        </select>
      ) : <span className="assigned-worker-badge">{item.worker || 'Unassigned'}</span>}
      {saving && <span role="status">Saving...</span>}
      {error && <span role="alert">{error}</span>}
    </div>
  );
}